export enum Routes {
  Default = "/",
  Login = "/login",
  PasswordReset = "/passwordReset",
  PasswordResetConfirmation = "/passwordResetConfirmation",
  PhoneNumber = "/phoneNumber",
  PhoneVerification = "/phoneVerification",
  Name = "/name",
  ResidentialAddress = "/residentialAddress",
  ResidentialAddressConfirmation = "/residentialAddressConfirmation",
  Citizenship = "/citizenship",
  Ssn = "/ssn",
  InvestmentPriority = "/investmentPriority",
  InvestmentDownturnReaction = "/investmentDownturnReaction",
  Employment = "/employment",
  EmployerAddressAutofill = "/employerAddressAutofill",
  EmployerAddress = "/employerAddress",
  EmployerAddressConfirmation = "/employerAddressConfirmation",
  AddBeneficiaryType = "/addBeneficiaryType",
  GoalType = "/goalType",
  GoalName = "/goalName",
  AccountType = "/accountType",
  GoalDeposit = "/goalDeposit",
  AddChild = "/addChild",
  ChildDeposit = "/childDeposit",
  BankLinking = "/bankLinking",
  Dashboard = "/dashboard",
  Fallback = "*",
}
